// Resolved at build time via Vite's `import.meta.env`. We expose them as
// VITE_*-prefixed env vars so they can be overridden per environment without
// rebuilding from source.
export const CONFIG = {
  apiBase:
    (import.meta.env.VITE_API_BASE as string | undefined) ??
    "https://72goxcydia.execute-api.us-east-1.amazonaws.com",
  cognitoRegion:
    (import.meta.env.VITE_COGNITO_REGION as string | undefined) ?? "us-east-1",
  cognitoClientId:
    (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ??
    "8rbv8m46ptmo17v002joj43uu",
};
